import clsx from 'clsx';
import * as React from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';

export type DescriptionProps = React.ComponentPropsWithoutRef<'div'>;

export const DescriptionContext = React.createContext<
    ContextValue<DescriptionProps, HTMLDivElement>
>({});

/**
 * Description.
 * @example
 * <Description>Some description</Description>
 */
export function Description({
    ref,
    ...props
}: DescriptionProps & { ref?: React.ForwardedRef<HTMLDivElement> }) {
    [props, ref] = useContextProps(props, ref, DescriptionContext);
    return (
        <div
            ref={ref}
            {...props}
            className={clsx(
                'peer/description peer/descriptor',
                'text-muted',
                // In group, if direct child preceded by label, adjust margin top.
                String.raw`group-has-[>.peer\/label+.peer\/description]/actionable-container:-mt-1`,
                // In group, if direct child preceded by heading, adjust margin top.
                String.raw`group-has-[>.peer\/heading+.peer\/description]/actionable-container:-mt-1`,
                props.className
            )}
        />
    );
}
